import { useState } from "react";

export function useAuthState() {
  const [isLoading, setIsLoading] = useState(false);
  return { isLoading, setIsLoading };
}
